// services/api.js
import axios from "axios";
import { tracking } from "@/networking/urlmanager";
import { getLocationAll } from '@/utils/detailData.js';

/**
 * Araç takip sistemine ait API isteklerini yöneten servis
 */
export const trackingService = {
  /**
   * Tüm araç konumlarını getir
   * @param {string} token - Kullanıcı kimlik doğrulama jetonu
   * @returns {Promise<Array>} - Araç verileri
   */
  async getAll(token) {
    try {
      // Mevcut uygulamada getLocationAll özelleştirilmiş fonksiyon kullanılıyor
      const data = await getLocationAll(token);
      return data;
      
      // Alternatif olarak doğrudan API çağrısı:
      // const response = await axios.get(
      //   tracking.getAll + "?isVehicleScreen=true",
      //   {
      //     headers: {
      //       Authorization: `Bearer ${token}`,
      //     },
      //   }
      // );
      // return response.data;
    } catch (error) {
      console.error("Konum verileri yüklenirken hata:", error);
      throw error;
    }
  },

  /**
   * Tüm fabrika/müşteri konumlarını getir
   * @param {string} token - Kullanıcı kimlik doğrulama jetonu
   * @returns {Promise<Array>} - Fabrika/müşteri verileri
   */
  async getVectors(token) {
    try {
      const response = await axios.get(tracking.getVectors, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data.data || [];
    } catch (error) {
      console.error("Vektör verileri yüklenirken hata:", error);
      throw error;
    }
  },

  /**
   * Belirli bir araç için detay verisi getir
   * @param {number} vehicleId - Araç ID'si
   * @param {string} token - Kullanıcı kimlik doğrulama jetonu
   * @returns {Promise<Object>} - Araç detay verisi
   */
  async getVehicleDetail(vehicleId, token) {
    try {
      const response = await axios.get(`${tracking.getVehicleDetail}/${vehicleId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error(`${vehicleId} ID'li araç detayları yüklenirken hata:`, error);
      throw error;
    }
  },

  /**
   * Araç konum geçmişini getir (Mobiliz /locations endpoint)
   * @param {Object} params - İstek parametreleri
   * @param {string} params.plate - Araç plakası
   * @param {number} params.muId - Mobiliz Unit ID (opsiyonel)
   * @param {number} params.fleetId - Filo ID (opsiyonel)
   * @param {number} params.groupId - Grup ID (opsiyonel)
   * @param {string} params.networkId - Network ID (opsiyonel)
   * @param {number} params.eventLogId - Event Log ID (opsiyonel)
   * @param {string} params.startTime - Başlangıç zamanı (ISO 8601, YYYY-MM-DDTHH:mm:ss+0000)
   * @param {string} params.endTime - Bitiş zamanı (ISO 8601, YYYY-MM-DDTHH:mm:ss+0000)
   * @param {string} token - Kullanıcı kimlik doğrulama jetonu
   * @returns {Promise<Object>} - Konum geçmişi verisi
   */
  async getVehicleLocations(params, token) {
    try {
      const response = await axios.get(`${tracking.getVehicleLocations}`, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Araç konum geçmişi yüklenirken hata:', error);
      throw error;
    }
  }
};